<template>
  <div class="BatterVisitViewContainer">
    <img src="../../assets/image/background.png" class="bg" />
    <StationMapView :menus="menus" :menusListLeft="menusListLeft" action-btn="预约参观"
                    :station-type="3"
                    :evaluate="{
                      type: 'STATION_VISIT',
                      name: '参观评价'
                    }"
                    :icon="icon"
                    @action="onAction" @goNavigation="goNavigation"></StationMapView>
  </div>
</template>

<script>
import StationMapView from "../map/StationMapView"
import {Toast} from "@nutui/nutui";
import api from "@/api";

export default {
  name: "BatterVisitView",
  components: {StationMapView},
  data() {
    return {
      menus: [
        {
          img: 'https://cdn.waityou.online/441bc5aa-e449-848e-b02e-c03401e348f1.png',
          name: '培训',
          link: '/train'
        },
        {
          img: 'https://cdn.waityou.online/4b9948f5-57b7-5c07-6dc2-b97f7dc81c31.png',
          name: '演练',
          link: '/drill/'
        },
        {
          img: 'https://cdn.waityou.online/21ea60b1-bc20-6cdc-3c34-84f9b185bdfb.png',
          name: '学习',
          link: '/study'
        },
        {
          img: 'https://cdn.waityou.online/c323b885-0d6b-70b9-6eed-d5d1a51afd6c.png',
          name: '咨询',
          link: '/consult'
        },
      ],
      menusListLeft: [
        {
          img: require('../../assets/image/left_1.png'),
          name: '培训',
          link: '/train'
        },
        {
          img: require('../../assets/image/left_2.png'),
          name: '演练',
          link: '/drill/'
        },
        {
          img: require('../../assets/image/left_3.png'),
          name: '学习',
          link: '/study'
        }
      ],
      icon:require('../../assets/image/visit_icon.png'),
    }
  },
  methods: {
    onAction(station) {
      api.checkIfVisitClosed()
          .then(() => {
            if (!station.stationTemplateId || station.openState == 'NO') {
              Toast.fail('很抱歉,该站点暂时无法接待')
              return
            }
            this.$router.push('/visit/visit/must/known/' + station.id)
          })
    },
    goNavigation(station){
      // eslint-disable-next-line no-undef
      ZWJSBridge.openLink({
        url: `zwfw://openThirdMap?longitude=${station.longitude}&latitude=${station.latitude}&locationName=${station.name}`
      }).then((result) => {
        console.log(result);
      }).catch((error) => {
        console.log(error);
      })
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.BatterVisitViewContainer {
  display: flex;
  flex-direction: column;
  // padding-bottom: 100px;
  .bg{
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
  }
}
</style>